import {useState, useCallback} from 'react';
import {translations} from 'presentation/translations-new';
import {ErrorCode, UseGeolocationState} from './types';

const {PERMISSION_DENIED, POSITION_UNAVAILABLE, TIMEOUT, NOT_SUPPORTED} = ErrorCode;
const {geolocationNotAllowed} = translations['pt-br'].commons;

export const useGeolocation = () => {
	const [geolocationState, setGeolocationState] = useState<UseGeolocationState>({
		loading: false,
		error: null,
		coords: null,
	});

	const resetCoords = useCallback(() => {
		setGeolocationState(prevState => ({
			...prevState,
			coords: null,
		}));
	}, []);

	const getPosition = useCallback((options?: PositionOptions) => {
		if (!navigator.geolocation) {
			setGeolocationState(prevState => ({
				...prevState,
				loading: false,
				error: {
					code: NOT_SUPPORTED,
					message: geolocationNotAllowed,
					PERMISSION_DENIED,
					POSITION_UNAVAILABLE,
					TIMEOUT,
				},
			}));
			return;
		}

		setGeolocationState(prevState => ({...prevState, loading: true, error: null}));

		const onSuccess = (position: GeolocationPosition) => {
			setGeolocationState(prevState => ({
				...prevState,
				loading: false,
				error: null,
				coords: {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				},
			}));
		};

		const onError = (error: GeolocationPositionError) => {
			setGeolocationState(prevState => ({
				...prevState,
				loading: false,
				error,
			}));
		};

		navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
	}, []);

	return {...geolocationState, getPosition, resetCoords};
};
